<script setup>
import { computed } from 'vue';

let props = defineProps({
	slug: {
		type: String,
		required: true
	}
});

let classes = computed(() => ['symbol', `symbol_${props.slug}`]);
let href = computed(() => `${window.WWW_ROOT}/images/icons.svg#${props.slug}`);
</script>

<template>
	<svg :class="classes">
		<use :xlink:href="href"></use>
	</svg>
</template>
